// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VideoPlayer from 'vue-video-player';

import 'element-ui/lib/theme-chalk/index.css';
import 'swiper/css/swiper.css'
import 'animate.css'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
// import './utils/rem.js';
import './assets/styles/global.less'
import tools from './utils/tools';
Vue.prototype.$tools = tools
Vue.prototype.$isMobile = ('ontouchstart' in document.documentElement)
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI)
Vue.use(VideoPlayer)

import myPlayer from './components/myPlayer.vue';// 引入
Vue.use(myPlayer)
Vue.component("myPlayer", myPlayer);// 全局注册

// 检测是否为苹果系统
const isMac = /Macintosh|macOS/i.test(navigator.userAgent);
console.log('asdasdas',isMac)
if (isMac) {
    document.documentElement.classList.add('mac-os');
} else {
    document.documentElement.classList.add('other-os');
}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App, myPlayer },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js